import axios from 'axios';
import { get } from "lodash";
import { getCookie, deleteCookie } from '../helpers/Storage';
console.log(process.env.REACT_APP_API_URL);
var api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

api.interceptors.request.use((config) => {
    let conf = {
        ...config,
        headers: {
            ...config.headers,
            'Content-Type': config.headers['Content-Type'] ? config.headers['Content-Type'] : 'application/json',
            'Authorization': 'Bearer ' + getCookie()
        }
    }
    return conf;
})

api.interceptors.response.use(response => {
    let data = get(response, "data");
    if (get(response, "data.status", 200) === 401) {
        //Remove token from local storage
        deleteCookie()
        //Redirect to login
        window.location = "/admin";
    }
    return {
        ...response,
        data
    }
}, (error) => {
    return Promise.reject(error)
})

export default api;